<template>
    <div>
        <div @click="showContent = !showContent">
            <div class="flex justify-between">
                <div>{{ title }}</div>
                <div class="font-bold text-lg mr-1.5">
                    {{ !showContent ? '+' : '-' }}
                </div>
            </div>
        </div>
        <div v-show="showContent">
            <slot name="content">
                Content goes here
            </slot>
        </div>
    </div>
</template>

<script>
export default {
    name: 'CollapsableListItem',

    props: {
        title: {
            default: 'Heading',
            type: String,
        },
    },

    data() {
        return {
            showContent: false,
        };
    },
};
</script>

<style></style>
